import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NumberControl} from '../../../models/uiArtefakt';
import {EventFondsService} from '../../../services/event-fonds.service';

export interface GespeichertesPortfolioData {
  wertEingabe: number;
  feldnameExtern: string;
}

@Component({
    selector: 'lv-fonds-table-gespeichertes-portfolio',
    templateUrl: './fonds-table-gespeichertes-portfolio.component.html',
    styleUrls: ['./fonds-table-gespeichertes-portfolio.component.scss'],
    standalone: false
})
export class FondsTableGespeichertesPortfolioComponent implements OnInit, OnDestroy {
  private _uiArtefakt: NumberControl;

  constructor(private _eventFondsService: EventFondsService) { }
  get uiArtefakt(): NumberControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: NumberControl) {
    this._uiArtefakt = uiArtefakt;
    if ('/PortfoliovorlageID' === this._uiArtefakt.FeldnameExtern) {
      if (!!this._eventFondsService.getInitialCheckVermittlerspezifischesPortfolioExecuted(this._uiArtefakt.FeldnameExtern) &&
          // Das !!this._uiArtefakt.WertEingabe entfernen wenn gewünscht ist daß bei änderung des aktuellen portfolios das dropdown
          // auf 'Neues Portfolio' switchen soll.
          !!this._uiArtefakt.WertEingabe) {
        this._eventFondsService.selectedVermittlerspezifischesPortfolioInvestitionsbetrag$.next(this._getGespeichertesPortfolioData());
      }
    }
    if ('/PortfoliovorlageZuzahlungID' === this._uiArtefakt.FeldnameExtern) {
      if (!!this._eventFondsService.getInitialCheckVermittlerspezifischesPortfolioExecuted(this._uiArtefakt.FeldnameExtern) &&
          // Das !!this._uiArtefakt.WertEingabe entfernen wenn gewünscht ist daß bei änderung des aktuellen portfolios das dropdown
          // auf 'Neues Portfolio' switchen soll.
          !!this._uiArtefakt.WertEingabe) {
        this._eventFondsService.selectedVermittlerspezifischesPortfolioZuzahlung$.next(this._getGespeichertesPortfolioData());
      }
    }
  }

  ngOnInit(): void {
    if ('/PortfoliovorlageID' === this._uiArtefakt.FeldnameExtern) {
      this._eventFondsService.selectedVermittlerspezifischesPortfolioInvestitionsbetrag$.next(this._getGespeichertesPortfolioData());
    }
    if ('/PortfoliovorlageZuzahlungID' === this._uiArtefakt.FeldnameExtern) {
      this._eventFondsService.selectedVermittlerspezifischesPortfolioZuzahlung$.next(this._getGespeichertesPortfolioData());
    }
  }

  ngOnDestroy(): void {
    const data = {} as GespeichertesPortfolioData;
    data.feldnameExtern = this._uiArtefakt.FeldnameExtern;
    data.wertEingabe = null;
    if ('/PortfoliovorlageID' === this._uiArtefakt.FeldnameExtern) {
      this._eventFondsService.selectedVermittlerspezifischesPortfolioInvestitionsbetrag$.next(data);
    }
    if ('/PortfoliovorlageID' === this._uiArtefakt.FeldnameExtern) {
      this._eventFondsService.selectedVermittlerspezifischesPortfolioZuzahlung$.next(data);
    }
  }

  private _getGespeichertesPortfolioData(): GespeichertesPortfolioData {
    const data = {} as GespeichertesPortfolioData;
    data.feldnameExtern = this._uiArtefakt.FeldnameExtern;
    data.wertEingabe = this._uiArtefakt.WertEingabe;
    return data;
  }
}
